import { isNil, last } from "lodash-es";
import type { EmailStatus, MailStatuses, Transition } from "../types/Submission";

const isQueuedEvent = (transition: Transition) => transition.status === "queued";

export const getLastMailTransition = (emailStatus: EmailStatus) => {
  // Transitions can be received in different order than they actually happened
  const transitions = [...emailStatus.transitions].sort((a, b) => a.date - b.date);
  // Make sure to always place the 'queued' event at the start, because it might have the exact same or later timestamp as other events
  transitions.sort((a) => (isQueuedEvent(a) ? -1 : 0));

  const lastTransition = last(transitions);
  if (isNil(lastTransition)) {
    return;
  }

  return {
    status: lastTransition.status,
    bounceDescription: lastTransition.bounceDescription,
    email: emailStatus.email,
  };
};

export const findMailTransitionsForFile = (pdfFileId: string, mailStatuses: MailStatuses[]) => {
  const mailStatus = mailStatuses.find((mailStatus) => mailStatus.pdfFileId === pdfFileId);
  if (isNil(mailStatus)) {
    return [];
  }

  return mailStatus.mailIds
    .map((mailId) => mailStatus.status[mailId])
    .map(getLastMailTransition)
    .filter((status) => !isNil(status));
};

const isWarningTransition = (status: Transition["status"]) => status === "reject" || status === "hard_bounce";

export const hasEmailWarnings = (mailStatuses: MailStatuses[]): boolean =>
  mailStatuses.some((mailStatus) =>
    Object.values(mailStatus.status).some((emailStatus) => {
      const transition = getLastMailTransition(emailStatus);
      return !isNil(transition) && isWarningTransition(transition.status);
    }),
  );
